<hr>
<h2>Edit Employee</h2><button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div >
    <form name="form" [formGroup]="myForm" (ngSubmit)="updateEmployee()" novalidate>
         <div class="form-group" >
                <input type="hidden" class="form-control" id="id" formControlName="id" required />
        </div>
        <div class="form-group" >
            <label for="fname">First name</label>
                @if (myForm.get('fname')?.invalid) 
                {
                @if (fname?.errors?.['required']) {
                        <div class="help-block">
                            First Name is required.
                        </div>
                }
                @if (fname?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            First Name has too many characters.
                    </div>
                }
                }            
            <input type="text" class="form-control" id="fname" formControlName="fname" required />
        </div>
        <div class="form-group" >
                <label for="lname">Last name</label>
                                      @if (myForm.get('lname')?.invalid) 
            {
                @if (lname?.errors?.['required']) {
                        <div class="help-block">
                            Last Name is required.
                        </div>
                }
                @if (lname?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Last Name has too many characters.
                    </div>
                }
            }            
                <input type="text" class="form-control" id="lname" formControlName="lname" required />
        </div>
        <div class="form-group" >
                <label for="employeecode">Employee Code (optional - autogenerated)</label>
                @if (myForm.get('employeecode')?.invalid) 
                {
                @if (employeecode?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Employee Code has too many characters.
                    </div>
                }
                }            
                <input type="text" class="form-control" id="employeecode" formControlName="employeecode"  />
                
        </div>
        <div class="form-group">
                <label for="uploaded">Date Uploaded: {{uploaded?.value == '0000-00-00' ? 'Pending' :uploaded?.value | date:'MM/dd/yyyy'}}</label>
        </div>
        <div class="form-group">
            <button type="submit" [disabled]="myForm.invalid" class="btn btn-primary">Update</button>
        </div>
    </form>
    
</div>